export const FEEDBACK_MAX_CHARACTERS = 250;

// customerInsights value passed by the unified Magic Apron Assistant ("planner") experience.
export const MAA_CUSTOMER_INSIGHTS = 'Planner';

export const filterData = (data) => Object.fromEntries(Object.entries(data).filter(([_, value]) => {
  return value !== '';
}));

export const createActionId = (sessionId, fallbackSessionId) => {
  if (!sessionId || sessionId === fallbackSessionId) {
    return `${crypto.randomUUID()}_${Date.now().toString()}`;
  }
  return `${sessionId}_${Date.now().toString()}`;
};